<template>
  <div
    class="modal show fade"
    :class="{ show: modalShow, fade: modalShow }"
    tabindex="-1"
    :style="modalShow ? 'display: block' : ''"
    @click="$emit('close')"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="$emit('close')"
          ></button>
        </div>
        <div class="modal-body p-0">
          <img :src="image" class="image" :alt="title" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Ligthbox',
  props: ['image', 'modalShow', 'title'],
  mounted() {
    document.addEventListener('keydown', e => {
      if (e.keyCode === 27) {
        this.$emit('close');
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.modal {
  background: rgba(0, 0, 0, 0.2);
  &-dialog {
    max-width: 90%;
  }
  &-content {
    border: 0;
    border-radius: 0;
  }
  &-header {
    border: 0;
  }
  .image {
    width: 100%;
  }
}
</style>
